import { motion } from "framer-motion";

export const AuthLayout = ({ title, subtitle, children, footer = true }) => (
  <div className="flex min-h-screen w-full items-center justify-center bg-cream px-6 py-12 sm:px-8">
    <motion.div
      className="w-full max-w-[420px]"
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <div className="flex justify-center">
        <span data-testid="setting-hub-logo" className="logo-hub text-3xl sm:text-4xl">The Setting Hub</span>
      </div>
      <motion.img
        data-testid="login-portrait"
        alt="Fanny, ta coach"
        className="mx-auto mt-6 w-56 sm:w-64"
        src="/img/fanny-login.webp"
        style={{ maskImage: "linear-gradient(rgb(0,0,0) 70%, transparent 100%)", WebkitMaskImage: "linear-gradient(rgb(0,0,0) 70%, transparent 100%)" }}
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.15, ease: "easeOut" }}
      />
      <div className="mt-4 text-center">
        <h1 data-testid="auth-title" className="font-sans text-4xl font-medium text-bordeaux-dark sm:text-5xl">{title}</h1>
        <p className="mt-3 font-sans text-sm font-light text-bordeaux sm:text-base">{subtitle}</p>
      </div>
      {children}
      {footer && (
        <p className="mt-10 text-center font-sans text-sm font-light text-ink-muted">
          Un souci de connexion ?{" "}
          <a data-testid="whatsapp-link" href="https://wa.me/33769310806" target="_blank" rel="noopener noreferrer" className="link-bordeaux font-normal">
            Envoie-moi un message sur WhatsApp.
          </a>
        </p>
      )}
    </motion.div>
  </div>
);
